import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class CacheUpdatedMessage extends Message {
    public constructor(params: any) {
        super(params);
    }
}

ComponentManager.setMessage('CacheUpdatedMessage', CacheUpdatedMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');